import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'app-home-page-country-dialog',
  templateUrl: './home-page-country-dialog.component.html',
  styleUrls: ['./home-page-country-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomePageCountryDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  countries = [];
  constructor() {
  }
  ngOnInit(): void {
    this.countries = this.data.input.countries;
  }
  onOkClicked() {
    return true;
  }


}
